import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  AlertTitle,
  Box,
  Typography,
} from '@mui/material'
import React from 'react'
import ClassCard from './ClassCard'
import useUserEnrolledClasses from '../../../../account/useUserEnrolledClasses'
import Loader from '../../../../../components/Loader'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const EnrolledClasses = ({ user, family }) => {
  return (
    <Box>
      <Typography mb={2} variant='h5' color='white.main'>
        CONFIRMED CLASS BOOKINGS
      </Typography>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography textTransform={'capitalize'}>
            {user.firstName} {user.lastName}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <EnrolledComp user={user} />
        </AccordionDetails>
      </Accordion>
      {family.map((member, i) => (
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography textTransform={'capitalize'}>
              {member.firstName} {member.lastName}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <EnrolledComp
              user={{
                dob: member.dob,
                firstName: member.firstName,
                lastName: member.lastName,
                id: member.id,
                mobile: user.mobile,
                primeId: user.id,
                email: user.email,
              }}
            />
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  )
}

export default EnrolledClasses

const EnrolledComp = ({ user }) => {
  const { enrolledClasses, loading, error } = useUserEnrolledClasses(user.id)

  if (loading) {
    return <Loader />
  }
  return (
    <>
      {error ? (
        <Alert severity='error'>
          <AlertTitle>Oops</AlertTitle>
          Error fetching enrolled classes for {user.firstName} {error}
        </Alert>
      ) : (
        <>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(18rem, 1fr))',
              gap: 2,
            }}
          >
            {!loading &&
              enrolledClasses.map((c, i) => (
                <ClassCard gymClass={c} user={user} key={c.id + i} />
              ))}
          </Box>
          {enrolledClasses.length === 0 && (
            <Alert severity='info'>
              <AlertTitle>Oops</AlertTitle>
              <Typography>{`${user.firstName} isn't confirmed on any classes yet.`}</Typography>
            </Alert>
          )}
        </>
      )}
    </>
  )
}
